import { experience } from './state'

const sounds = {
  correct: new Audio('/audio/correct.wav'),
  wrong: new Audio('/audio/wrong.wav'),
  complete: new Audio('/audio/complete.wav'),
}
Object.values(sounds).forEach(audio => { audio.preload = 'auto'; audio.volume = 0.42 })

export function playFeedback(kind) {
  if (!experience.sound_enabled || !sounds[kind]) return
  const audio = sounds[kind]
  try {
    audio.pause(); audio.currentTime = 0
    audio.play().catch(() => {})
  } catch {}
}

export function effectsEnabled() {
  return experience.effects_level !== 'off' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches
}
